// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1LabelsUpdateSchema = z.object({
  label: z.object({
    name: z.coerce.string().max(255).nullish(),
    emoji: z.coerce.string().nullish(),
    parent_id: z.number().int().nullish(),
    sequence: z.number().int().nullish(),
    active: z.boolean().nullish(),
    external_id: z.coerce.string().max(512).nullish(),
  }),
});
